import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
import { ref, watchEffect } from '../../../adapter-vue';
import { isWeChat } from '../../../utils/env';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    show: {
      type: Boolean,
      default: () => false
    }
  },
  emits: ['update:show'],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var props = __props;
    var showMask = ref(false);
    watchEffect(() => {
      showMask.value = props.show;
    });
    var emit = __emit;
    var toggleView = () => {
      showMask.value = !showMask.value;
      emit('update:show', showMask.value);
    };
    return (_ctx, _cache) => {
      return _unref(showMask) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "mask",
        onClick: _cache[0] || (_cache[0] = _withModifiers($event => !_unref(isWeChat) && toggleView, ["self"]))
      }, [_renderSlot(_ctx.$slots, "default")])) : _createCommentVNode("", true);
    };
  }
});